import React from 'react';
import useClassNames from '@medflex/hooks/useClassNames';
import EditPencil from '../../icons/EditPencil';

const SessionsDetailModalSectionTitle = ({ onEdit, isEditable, className, children }) => {
  const cn = useClassNames(() => ['flex', 'items-center', 'space-x-4', className], [className]);
  return (
    <div className={cn}>
      <h3 className="text-xl font-semibold mb-2 flex items-center">{children}</h3>
      {isEditable && (
        <button
          aria-label="edit"
          type="button"
          className="text-slate-500 hover:text-slate-600 focus:outline-none"
          onClick={onEdit}
        >
          <EditPencil size="5" className="fill-current" />
        </button>
      )}
    </div>
  );
};

export default SessionsDetailModalSectionTitle;
